import React, { Fragment } from 'react'

import { connect } from 'react-redux'

import { Load_Department_List, get_Department_Action_Id } from '../../../../Store/Actions/Setting.Action'

import CoTable from '../../../Containers/Table'
import GenericModals from '../../../Containers/GenericModals'

import Add from './Modal/Department/Add'
import Edit from './Modal/Department/Edit'
import View from './Modal/Department/View'
import Delete from './Modal/Department/Delete'
import { Modal } from '@mui/material'

class SettingDepartment extends React.Component {
    componentDidMount() {
        this.props.Load_Department_List()
    }
    onClickActionId(Id) {
        this.props.get_Department_Action_Id(Id)
    }

    render() {
        const DepartmentList = this.props.DepartmentList
        const HeadData = [
            {
                Nama: 'No',
                width: '5%',
            },
            {
                Nama: 'Id',
                width: '15%',
            },
            {
                Nama: 'Nama',
                width: '30%',
            },
            {
                Nama: 'Deskripsi',
                width: '30%',
            },
            {
                Nama: 'View',
                width: '10%',
            },
            {
                Nama: 'Edit',
                width: '10%',
            },
            {
                Nama: 'Delete',
                width: '10%',
            },
        ]
        const BodyData = DepartmentList ? DepartmentList.map((item, index) => {
            return {
                index: index + 1,
                Id: item.Id,
                Name: item.Nama,
                Deskripsi: item.Deskripsi,
                View: (
                    <GenericModals
                        size='xl'
                        header='View Department'
                        body={<View />}
                        Buttoncolor='primary'
                        ButtononClickeven={() => this.onClickActionId(item.Id)}
                        Buttonlabel={'view'}
                    />
                ),
                Edit: (
                    <GenericModals
                        size='xl'
                        header='Edit Department'
                        body={<Edit />}
                        Buttoncolor='warning'
                        ButtononClickeven={() => this.onClickActionId(item.Id)}
                        Buttonlabel={'edit'}
                    />
                ),
                Delete: (
                    <GenericModals
                        size='m'
                        header='Delete Form'
                        body={<Delete />}
                        Buttoncolor='error'
                        ButtononClickeven={() => this.onClickActionId(item.Id)}
                        Buttonlabel={'Delete'}
                    />
                )
            }
        }) : []
        const isDepartmentLoading = this.props.isDepartmentLoading
        return (
            <Fragment>
                <h2>
                    Department Setting
                </h2>

                <center>
                    <GenericModals
                        size='m'
                        header='Tambah Department'
                        body={<Add />}
                        Buttoncolor='primary'
                        Buttonstyle={{ width: '90%' }}
                        ButtononClickeven={() => null}
                        Buttonlabel={'+ Department'}
                    />
                </center>

                <CoTable
                    TableId='DepartmentSetting'
                    HeadData={HeadData}
                    isHeadLoading={HeadData ? false : true}
                    Data={BodyData}
                    isBodyLoading={isDepartmentLoading}
                />
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    isDepartmentLoading: state.Setting.isDepartmentLoading,
    DepartmentList: state.Setting.DepartmentList,
})

export default connect(mapStateToProps, { Load_Department_List, get_Department_Action_Id })(SettingDepartment)
